import React, { useEffect, useRef, useState } from 'react';

const ActivityDetector = ({ 
    onActivity = () => {}, 
    onInactivity = () => {},
    inactiveTimeout = 30000, // 30 seconds default
    children 
}) => {
    const [isActive, setIsActive] = useState(true);
    const [lastActivity, setLastActivity] = useState(Date.now());
    const timeoutRef = useRef(null);

    // Use refs to store current callbacks (always latest version)
    const onInactivityRef = useRef(onInactivity);
    const onActivityRef = useRef(onActivity);

    useEffect(() => {
        onInactivityRef.current = onInactivity;
    }, [onInactivity]);
    
    useEffect(() => {
        onActivityRef.current = onActivity;
    }, [onActivity]);

    // Reset the inactive timeout
    const resetTimeout = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        
        timeoutRef.current = setTimeout(() => {
            setIsActive(false);
            onInactivityRef.current(Date.now());
        }, inactiveTimeout);
    };

    // Handle user activity
    const handleActivity = () => {
        const now = Date.now();
        setLastActivity(now);
        
        if (!isActive) {
            setIsActive(true);
        }
        
        onActivityRef.current(now);
        resetTimeout();
    };

    useEffect(() => {
        // List of events to listen for
        const events = [
            'mousedown', 'mousemove', 'mouseup', 'keydown', 'keyup',
            'touchstart', 'touchmove', 'touchend', 'wheel', 'scroll'
        ];

        // Add event listeners
        events.forEach(event => {
            document.addEventListener(event, handleActivity, { passive: true });
        });

        // Initialize timeout
        resetTimeout();

        // Cleanup function
        return () => {
            events.forEach(event => {
                document.removeEventListener(event, handleActivity);
            });
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [isActive, inactiveTimeout]);

    return (
        <div>
            {children}
            <div style={{ display: 'none' }}>
                {/* Hidden status indicator */}
                Status: {isActive ? 'Active' : 'Inactive'} | 
                Last activity: {Date.now() - lastActivity}ms ago
            </div>
        </div>
    );
};

export default ActivityDetector;